import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Stack, Typography } from '@mui/material';
import { GetStatusInfo } from './shared/TestDashboardComponents';

export const ChecklistDisplay = ({ items = [] }) => {
  if (items.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
        <Typography variant="body2">No items to display</Typography>
      </Box>
    );
  }

  return (
    <Stack
      sx={{
        gap: 0.5,
        height: '100%',
        overflow: 'auto',
        maxHeight: '250px',
      }}
    >
      {items.map((item) => {
        const statusInfo = GetStatusInfo(item.status);

        return (
          <Box
            key={item.code}
            sx={{
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              borderRadius: 1,
              '&:hover': {
                bgcolor: 'action.hover',
              },
            }}
          >
            {/* Status Icon */}
            <FontAwesomeIcon icon={statusInfo.icon} style={{ fontSize: 16, color: statusInfo.color, flexShrink: 0 }} />

            {/* Content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="body2"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.name || item.code}
              </Typography>
              {item.runTime && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  {new Date(item.runTime).toLocaleString()}
                </Typography>
              )}
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
};
